import React from 'react';
import { StyleSheet, View } from 'react-native';
import Svg, { Path } from 'react-native-svg';

export { Path };

export const MapSVGLayer = ({ width, height, children }) => (
  <View style={styles.container}>
    <Svg height={'100%'} viewBox={`0 0 ${width} ${height}`} width={'100%'}>
      {children}
    </Svg>
  </View>
);

const styles = StyleSheet.create({
  container: {
    ...StyleSheet.absoluteFill,
    alignItems: 'center',
    justifyContent: 'center',
  },
});
